import { TZDate } from "@date-fns/tz"
import { Controller } from "@hotwired/stimulus"
import { format } from "date-fns"

export default class extends Controller {
  static targets = ["startTime", "timeZone", "timeZoneLabel"]

  connect() {
    this.updateTimeZone()
  }

  updateTimeZone() {
    const min = TZDate.tz(this.#timeZone)
    const formatted = format(min, "yyyy-MM-dd'T'HH:mm")

    this.startTimeTarget.min = formatted
    this.timeZoneLabelTargets.forEach(target => {
      target.innerText = `(${this.#timeZone})`
    })
  }

  get #timeZone() {
    return this.timeZoneTarget.value
  }
}
